/**
 * Map tab-summary circle block into the integrated circle payload shape.
 * Same ownership filters as GET /api/play/circle.
 */
export function circlePayloadFromTabSummary(summary: {
  circle: {
    totalCount: number
    returnedCount: number
    relationships: import('@/lib/play/playCircleReadService').PlayCircleRelationshipDto[]
    activeDog: { id: string; name: string; photoUrl: string | null }
  }
}): {
  success: true
  activeDog: { id: string; name: string; photoUrl: string | null }
  circle: {
    totalCount: number
    returnedCount: number
    relationships: import('@/lib/play/playCircleReadService').PlayCircleRelationshipDto[]
  }
} {
  return {
    success: true,
    activeDog: summary.circle.activeDog,
    circle: {
      totalCount: summary.circle.totalCount,
      returnedCount: summary.circle.returnedCount,
      relationships: summary.circle.relationships,
    },
  }
}

export function tabSummaryHasPaintableCircle(summary: {
  circle?: {
    relationships?: unknown
    activeDog?: { id?: string }
  }
}): boolean {
  return Boolean(
    summary.circle &&
      Array.isArray(summary.circle.relationships) &&
      summary.circle.activeDog?.id
  )
}
